import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

export default function ConfirmLeaveDialog({ open, onClose, onLeave }) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Є незбережені зміни</DialogTitle>
            <DialogContent>
                <Typography variant="body2">Якщо вийти зараз — зміни буде втрачено.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" type="button">
                    Залишитись
                </Button>
                <Button onClick={onLeave} variant="contained" type="button">
                    Вийти
                </Button>
            </DialogActions>
        </Dialog>
    );
}